import React, { useState,useEffect } from 'react';
import { makeRequest } from "../../../axios";
import { AuthContext } from "../../../authcontext/authContext";
import "./userdb.scss"

const SimpleForm = () => {
  const [formData, setFormData] = useState({ title: '', description: '' });
  const [userInfo, setUserInfo] = useState({})

  // Handle input and text area changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value, email:userInfo.info?.email});
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Title: ${formData.title}\nDescription: ${formData.description}`);
    setFormData({ title: '', description: '' }); // Clear form after submission
  };

  useEffect(() => {
    makeRequest.get("user-info/user").then((res) => {
      setUserInfo(res.data)
     
    } 
    )
   
  }, []);

  return (
    <div className="form-container">
      <h2>Request Support</h2>
      <form onSubmit={handleSubmit}>
        <label htmlFor="title">Email:</label>
        <input
          type="text"
          id="title"
          name="title"
          value={formData.title}
          onChange={handleChange}
          placeholder="Enter title"
        />

        <label htmlFor="description">Description:</label>
        <textarea
          id="description"
          name="description"
          value={formData.description}
          onChange={handleChange}
          placeholder="Enter description"
          rows="4"
        ></textarea>

        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

export default SimpleForm;
